import { useMemo } from 'react';

const LAMBDA_BASE_URL = 'https://pryvw6vsbf7zfgtoyrmgbwvtqm0kcphn.lambda-url.us-east-2.on.aws';
const ASSETS_ENDPOINT = process.env.REACT_APP_INFRA_ASSETS_ENDPOINT || '';

/**
 * Resolves an image URL through the Lambda image optimizer,
 * but ONLY when the source URL belongs to our own S3 assets endpoint.
 * External URLs (Zoho, CDNs, data URIs, etc.) are returned unchanged.
 */
const useLambdaImage = (src, width, quality = 75) => {
    return useMemo(() => {
        if (!src) return '';

        // Pass external / non-S3 URLs straight through — no Lambda needed
        if (!ASSETS_ENDPOINT || !src.startsWith(ASSETS_ENDPOINT)) {
            return src;
        }

        // Strip the S3 origin (https://sawpy-assets.s3.us-east-2.amazonaws.com/...)
        // so the Lambda receives only the object key
        let cleanPath = src
            .slice(ASSETS_ENDPOINT.length)   // remove the known base
            .replace(/^\//, '');             // drop leading slash

        // Also strip bucket name prefix if it appears at the start of the key
        cleanPath = cleanPath.replace(/^sawpy-assets\//, '');

        let finalUrl = `${LAMBDA_BASE_URL}/${cleanPath}`;

        const params = [];
        if (width)   params.push(`w=${width}`);
        if (quality) params.push(`q=${quality}`);
        if (params.length > 0) finalUrl += `?${params.join('&')}`;

        return finalUrl;
    }, [src, width, quality]);
};

export default useLambdaImage;
